import { LinkWalletURI, LinkableWallet } from "@payment-client/interfaces/WalletPublic";
import { VALID_WALLET_LINK_STATUSES } from "@swiggy-private/payment-core";

export const APAY = {
    SIGN_AND_ENCRYPT: "/api/v3/amazonpay/sign-and-encrypt",
};

export const CORPORATE_WALLET_DELINK_URI = "/api/v1/unlink-account";

export const LINK_WALLET_URI: LinkWalletURI = {
    [LinkableWallet.PAYTM]: {
        checkBalance: "/api/v3/user/paytmwallet/check_balance",
        link: "/api/v3/user/paytmwallet/link",
        delink: "/api/v3/user/paytmwallet/delink",
        validateOtp: "/api/v3/user/paytmwallet/validate",
        ssoToken: "/api/v3/user/paytmwallet/sso_token",
    },
    [LinkableWallet.PAYTMPOSTPAID]: {
        delink: { endpoint: "/api/paylater/paytm/v3/delink", method: "DELETE" },
    },
    [LinkableWallet.SIMPL]: {
        delink: { endpoint: "/api/v3/paylater/simpl/delink", method: "DELETE" },
    },
    [LinkableWallet.AMAZONPAY]: {
        checkBalance: "/api/v1/user/apay/getBalance?paymentInstrument=AmazonPayBalance",
        delink: { endpoint: "/api/v1/user/apay/delink", method: "DELETE" },
        link: "/api/v1/user/apay/link",
    },
    [LinkableWallet.PHONEPE]: {
        checkBalance: "/api/v3/payment/phonepe/getUserProfile",
        link: "/api/v3/payment/phonepe/getOtp",
        delink: { endpoint: "/api/v3/payment/phonepe/delink", method: "DELETE" },
        validateOtp: "/api/v3/payment/phonepe/validateOtp",
    },
    [LinkableWallet.MOBIKWIK]: {
        checkBalance: "/api/v3/mobikwik/wallet/check_balance",
        link: "/api/v3/mobikwik/wallet/link",
        delink: "/api/v3/mobikwik/wallet/delink",
        validateOtp: "/api/v3/mobikwik/wallet/validate",
        ssoToken: "/api/v3/mobikwik/wallet/sso_token",
        calculateChecksum: "/api/v3/mobikwik/wallet/calculate_checksum",
    },
};

// v3:  Add paylater endpoints

type StatusCodeToLinkStatus = {
    [key in LinkableWallet]: { [key: number]: VALID_WALLET_LINK_STATUSES };
};

export const DEEP_WALLET_SUFFIX = "-SSO";

export const STATUS_CODE_TO_LINK_STATUS: StatusCodeToLinkStatus = {
    [LinkableWallet.PAYTM]: {
        0: VALID_WALLET_LINK_STATUSES.LINKED,
        1: VALID_WALLET_LINK_STATUSES.TOKEN_EXPIRED,
        100: VALID_WALLET_LINK_STATUSES.RETRY,
    },
    [LinkableWallet.PAYTMPOSTPAID]: {
        0: VALID_WALLET_LINK_STATUSES.LINKED,
        1: VALID_WALLET_LINK_STATUSES.TOKEN_EXPIRED,
        100: VALID_WALLET_LINK_STATUSES.RETRY,
    },
    [LinkableWallet.SIMPL]: {
        0: VALID_WALLET_LINK_STATUSES.LINKED,
        1: VALID_WALLET_LINK_STATUSES.TOKEN_EXPIRED,
        100: VALID_WALLET_LINK_STATUSES.RETRY,
    },
    [LinkableWallet.MOBIKWIK]: {
        0: VALID_WALLET_LINK_STATUSES.LINKED,
        1: VALID_WALLET_LINK_STATUSES.RETRY,
        2: VALID_WALLET_LINK_STATUSES.NEVER_LINKED,
        3: VALID_WALLET_LINK_STATUSES.TOKEN_EXPIRED,
        100: VALID_WALLET_LINK_STATUSES.RETRY,
    },
    [LinkableWallet.PHONEPE]: {
        0: VALID_WALLET_LINK_STATUSES.LINKED,
        1: VALID_WALLET_LINK_STATUSES.RETRY,
        2: VALID_WALLET_LINK_STATUSES.BLOCKED,
        3: VALID_WALLET_LINK_STATUSES.BLACK_LISTED,
        5: VALID_WALLET_LINK_STATUSES.TRY_AFTER_SOME_TIME,
        8: VALID_WALLET_LINK_STATUSES.TOKEN_EXPIRED,
        9: VALID_WALLET_LINK_STATUSES.NEVER_LINKED,
    },
    [LinkableWallet.AMAZONPAY]: {
        0: VALID_WALLET_LINK_STATUSES.LINKED,
        1: VALID_WALLET_LINK_STATUSES.GENERIC_FAILURE,
    },
};
